import type { SubmitDocumentMigrationParams } from "@api/accountingIntegration.api";
import type { MigrationMatchedRow } from "./migrationFileMatching.types";
import { isMigrationRowReadyForFinalize } from "./migrationExtractionWarnings";

function readyDocumentId(
    rows: MigrationMatchedRow[],
    role: MigrationMatchedRow["role"],
): number | undefined {
    return rows.find(
        (row) =>
            row.role === role && isMigrationRowReadyForFinalize(row.status),
    )?.documentId;
}

export function getMigrationDocumentIds(
    rows: MigrationMatchedRow[],
): SubmitDocumentMigrationParams | null {
    const coaDocumentId = readyDocumentId(rows, "coa");
    if (coaDocumentId == null) {
        return null;
    }

    const glDocumentIds: number[] = [];
    for (const row of rows) {
        if (
            isMigrationRowReadyForFinalize(row.status) &&
            row.documentId != null &&
            (row.role === "cashGl" || row.role === "accrualGl")
        ) {
            glDocumentIds.push(row.documentId);
        }
    }
    if (glDocumentIds.length === 0) {
        return null;
    }
    return { coaDocumentId, glDocumentIds };
}
